// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var ref = allVue.ref;
import { classNames, getRef, getTabIndex, getTemplate, Icon, setRef } from '@progress/kendo-vue-common';
/**
 * @hidden
 */
var FloatingActionButtonItemVue2 = {
  name: 'KendoVueFloatingActionButtonItem',
  props: {
    disabled: Boolean,
    focused: Boolean,
    index: Number,
    icon: String,
    item: [String, Function, Object],
    dataItem: Object,
    text: String,
    tabIndex: Number,
    customProp: [String, Function, Object]
  },
  // @ts-ignore
  emits: {
    'click': null,
    'down': null
  },
  mounted: function mounted() {
    this.element = getRef(this, 'element');
  },
  computed: {
    itemClassNames: function itemClassNames() {
      return classNames('k-fab-item', {
        'k-focus': this.focused,
        'k-disabled': this.disabled
      });
    }
  },
  methods: {
    handleClick: function handleClick(event) {
      if (this.$props.index !== undefined && !this.$props.disabled) {
        this.$emit('click', event, this.$props.index);
      }
    },
    focusElement: function focusElement() {
      if (this.$el) {
        this.$el.focus();
      }
    },
    onDown: function onDown(event) {
      this.$emit('down', event);
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    var elementRef = ref(null);
    return {
      v3: v3,
      elementRef: elementRef
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    var _a = this.$props,
      disabled = _a.disabled,
      id = _a.id,
      tabIndex = _a.tabIndex,
      dataItem = _a.dataItem;
    var text = dataItem.text,
      icon = dataItem.icon,
      svgIcon = dataItem.svgIcon;
    var item;
    var itemDefaultRendering = h("li", {
      ref: setRef(this, 'element'),
      id: id,
      attrs: this.v3 ? undefined : {
        id: id,
        role: 'menuitem',
        tabindex: getTabIndex(tabIndex, disabled),
        "aria-disabled": disabled,
        "aria-label": "".concat(text || '', " floatingactionbutton item")
      },
      "class": this.itemClassNames,
      role: 'menuitem',
      tabindex: getTabIndex(tabIndex, disabled),
      "aria-disabled": disabled,
      "aria-label": "".concat(text || '', " floatingactionbutton item"),
      onClick: this.handleClick,
      on: this.v3 ? undefined : {
        "click": this.handleClick,
        "mousedown": this.onDown,
        "pointerdown": this.onDown
      },
      onMousedown: this.onDown,
      onPointerdown: this.onDown
    }, [text && h("span", {
      "class": "k-fab-item-text"
    }, [text]), icon && h(Icon, {
      name: icon,
      attrs: this.v3 ? undefined : {
        name: icon,
        icon: svgIcon
      },
      icon: svgIcon,
      "class": "k-fab-item-icon"
    })]);
    item = getTemplate.call(this, {
      h: h,
      template: this.$props.item,
      defaultRendering: itemDefaultRendering,
      additionalProps: this.$props,
      additionalListeners: {
        click: this.handleClick
      }
    });
    return item;
  }
};
/**
 * @hidden
 */
var FloatingActionButtonItem = FloatingActionButtonItemVue2;
export { FloatingActionButtonItem, FloatingActionButtonItemVue2 };